
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/en/terms-of-service",
      function () {
        return require("private-next-pages/nl/en/terms-of-service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/en/terms-of-service"])
      });
    }
  